<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm">
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" type="text" placeholder="Title" #title>
      <mat-error *ngIf="inputForm.controls['title'].hasError('required')">
        Title is required!
      </mat-error>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description" type="text"
                placeholder="Description (Optional)" rows="5">
             </textarea>
    </mat-form-field>
  </div>
  <mat-checkbox (change)="onSingleExecutionSelectionChange($event.checked)">
    Single Execution
  </mat-checkbox>
</form>
